var map = {
	"./logo-512.png": 89078,
	"./logo-CUHK.png": 13438,
	"./logo-HKU.png": 86474,
	"./logo-UST.png": 27505,
	"./logo-title-dark.png": 28353,
	"./logo-title-light.png": 22010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55652;